"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signTransaction = void 0;
const types_1 = require("../../types.js");
const signTransaction = (_transaction, _args) => {
    throw new types_1.SignTransactionNotSupportedBySmartAccount();
};
exports.signTransaction = signTransaction;
//# sourceMappingURL=signTransaction.js.map